/*
 * Dropdown select of reseller program for the vendor portal reseller page tab that enables vendor selection / management
 * of a resale program for a reseller.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';
import { FormControl, Input, InputLabel, NativeSelect } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    width: '97%',
    minWidth: 120,
  },
  nselect: {
    paddingLeft: 0,
  },
});

const ResellerCommProgramSelectQuery = graphql`
query ResellerCommProgramSelectQuery($vendorAccountId: UUID!, $first: Int) {
  allCpTs(condition: {accountId: $vendorAccountId, publicView: 1}, first: $first, orderBy: PROGRAM_NAME_ASC) {
	totalCount
    nodes {
      cpId
      programType
      programName
      description
      qualificationPeriod
      autoPayout
    }
  }
}
`;

class ResellerCommProgramSelect extends Component {

  setProgramIdState = (aValue, pNodes) => {
    if (pNodes && pNodes.length > 0) {
      // Find the match in the node list
      for (let i=0; i<pNodes.length; i++) {
        if (aValue === pNodes[i].cpId) {
          this.props.setProgramIdState(JSON.stringify(pNodes[i]));
          return;
        }
      }
    }
  };

  render() {
    const classes = this.props.classes;
    let maxPrograms = 40;
    let cpId = this.props.cpId;

    let widthOverride = null;
    if (this.props.widthOverride != null) {
      widthOverride = this.props.widthOverride;
    }

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={ResellerCommProgramSelectQuery}
        variables={{vendorAccountId: this.props.vendorAccountId, first: maxPrograms}}
        render={({error, props})=> {
          if (error) {
            return (
              <FormControl 
                className={classes.formControl}
                style={
                  widthOverride == null
                  ? {
                      'width': '97%'
                    }
                  : {
                      'width': widthOverride
                    }
                }
              >
                {/* <InputLabel shrink htmlFor="commissionplan">Commission plan{this.props.showRequired ? ' *' : ''}</InputLabel> */}
                <NativeSelect
                  value=""
                  input={<Input name="commissionplan" id="commissionplan" />}
                  className={classes.nselect}
                >
                  <option key="" value="">Loading...</option>
                </NativeSelect>
              </FormControl>
            );
          } else if (props) {
            // Options from result of query
            // Also, look for the object that matches the current pId.
            let pNodes = props.allCpTs.nodes;

            // If a set of restrictions are passed in, use these to narrow the selection.
            let alreadyAssigned = [];
            if (this.props.alreadyAssigned != null) {
              alreadyAssigned = this.props.alreadyAssigned;
            }

            if (alreadyAssigned.length > 0) {
              let newArray = [];
              for (let i=0; i<pNodes.length; i++) {
                let pNode = pNodes[i];
                let addToList = true;
                for (let j=0; j<alreadyAssigned.length; j++) {
                  if (pNode.cpId === alreadyAssigned[j]) {
                    addToList = false;
                    break;
                  }
                }

                if (addToList === true) {
                  newArray.push(pNode);
                }
              }

              pNodes = newArray;
            }

            let theVal = null;
            if (cpId != null) {
              theVal = cpId;
            }
            if (theVal == null) {
              theVal = "";
            }

            return (
              <FormControl 
                className={classes.formControl}
                style={
                  widthOverride == null
                  ? {
                      'width': '97%'
                    }
                  : {
                      'width': widthOverride
                    }
                }
              >
                {/* <InputLabel shrink htmlFor="commissionplan">Commission plan{this.props.showRequired ? ' *' : ''}</InputLabel> */}
                <NativeSelect
                  value={theVal}
                  input={<Input name="commissionplan" id="commissionplan" />}
                  onChange={(e) => this.setProgramIdState(e.target.value, pNodes)}
                  className={classes.nselect}
                  disabled={this.props.stage === 1 || pNodes.length === 0}
                >
                  <option key="" value="">Select a commission plan</option>
                  {pNodes.map(n => {
                    return(<option key={n.cpId} value={n.cpId}>{n.programName}</option>);
                  })}
                </NativeSelect>
              </FormControl>
            );
          }

          return (
            <FormControl 
              className={classes.formControl}
              style={
                widthOverride == null
                ? {
                    'width': '97%'
                  }
                : {
                    'width': widthOverride
                  }
              }
            >
              <InputLabel shrink htmlFor="commissionprogram">Commission program{this.props.showRequired ? ' *' : ''}</InputLabel>
              <NativeSelect
                value=""
                input={<Input name="commissionprogram" id="commissionprogram" />}
                className={classes.nselect}
              >
                <option key="" value="">Loading...</option>
              </NativeSelect>
            </FormControl>
          );
        }}
      />
    );
  }
    
}

export default withStyles(styleSheet)(ResellerCommProgramSelect);
